import styled from '@emotion/styled'
import { Avatar } from 'antd'

export const AvatarIcon = styled(Avatar)(({ bgcolor, color }) => ({
	backgroundColor: bgcolor,
	color
}))